<template>
	<div style="padding: 0px 15%; min-height: 100vh">
		<div v-if="quiz && !getTimeIsOverModal">
			<learning-question :name="quiz.name" :id="quiz.id" />
			<learning-quiz-box
				v-for="(question, i) in quiz.answers"
				:key="i"
				:questionId="quiz.id"
				:id="question.id"
				:name="question.name"
			/>
			<button
				v-if="!lastQuestion"
				:disabled="nextQuestion"
				@click.prevent.stop="acceptAnswer()"
				class="btn btn-primary mb-2"
			>
				zatwierdź
			</button>
			<button
				v-else
				:disabled="nextQuestion"
				@click.prevent.stop="sendAnswers()"
				class="btn btn-primary mb-2"
			>
				zatwierdź i sprawdź wynik
			</button>
		</div>
	</div>
</template>
<script>
import LearningQuizBox from './partial/LearningQuizBox';
import LearningQuestion from './partial/LearningQuestion';
import { mapGetters } from 'vuex';
export default {
	data() {
		return {
			leavePage: false,
			changePath: '',
		};
	},
	components: {
		LearningQuizBox,
		LearningQuestion,
	},
	computed: {
		...mapGetters([
			'getSelectedAnswer',
			'getAllAnswers',
			'getTimeIsOverModal',
		]),
		quiz() {
			let step = this.$store.getters.getQuestionQuiz;
			let question = this.$store.getters.getQuizQuestions;
			return question[step];
		},
		nextQuestion() {
			return this.getSelectedAnswer ? false : true;
		},
		lastQuestion() {
			return (
				this.$store.getters.getQuestionQuiz + 1 ===
				this.$store.getters.getQuizQuestions.length
			);
		},
	},
	methods: {
		acceptAnswer() {
			let anwser = this.getSelectedAnswer;
			let step = this.$store.getters.getQuestionQuiz;
			step++;
			step = step === 40 ? 39 : step;
			this.$store.commit('setQuestionQuiz', step);
			this.$store.commit('setAllAnswers', anwser);
			this.$store.commit('setSelectedAnswer', '');
			this.$store.commit('setChangePath', true);
		},
		sendAnswers() {
			this.acceptAnswer();
			this.$store.dispatch('sendAnwsers');
		},
	},
	beforeMount() {
		this.$store.commit('setChangePath', false);
		this.$store.commit('setTimeIsOverModal', false);
	},
	beforeUnmount() {
		this.$store.commit('setIsTestAllow', false);
		this.$store.commit('setQuestionQuiz', 0);
		this.$store.commit('clearAllAnswers');
		// this.$store.allAnswers = [];
		this.$store.commit('setSelectedAnswer', '');
		this.$store.commit('setLearningModal', false);
	},
	beforeRouteLeave(to, from, next) {
		let now = new Date();
		if (now < new Date(sessionStorage.getItem('expirationDate'))) {
			let accpet = this.$store.getters.getChangePath;
			if (accpet) {
				this.$store.commit('setChangePath', false);
				next();
			} else {
				this.$store.commit('setIsLeaving', true);
				this.$store.commit('setLearningModal', true);
				this.$store.commit('setPath', to.path);
			}
		} else {
			next();
		}
	},
};
</script>
